export default __webpack_public_path__ + "static/media/finanzasbc.a5cdcd06.png";